import { z } from 'zod';

export const smsValidationSchema = z.object({
  message: z.string().min(1, 'Required'),
  serviceDepartmentId: z.number().min(1, 'Required')
});

export type FormValues = z.input<typeof smsValidationSchema>;
